// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"a08f9eef","650":"021fc88b"}[chunkId] + ".chunk.js";
};